/** 並べ替えの入力。1 地点が複数 operation を持つ（同じ拠点で複数伝票） */
export type PlaceOperations = { operationIds: number[] };
export type CycleOperations = { cycleIndex: number; places: PlaceOperations[] };

/**
 * 訪問順の並べ替えを保存するときに送る operation id 列を作る。
 *
 * V3Plans (presenters/PlanningsCycle.presenter.tsx:174-188) と同じく、
 * 並べ替えた回転は新しい順、それ以外の回転は今の順で、delivery 全体を並べて返す。
 *
 * Why 全回転を返す: 対象の回転だけ送ると、他の回転の operation が
 * order_operation_ids_for_sort に含まれず計画から落ちる。
 */
export function buildSortedOperationIds(
  cycles: readonly CycleOperations[],
  targetCycleIndex: number,
  sortedPlaces: readonly PlaceOperations[],
): number[] {
  return cycles.flatMap((cycle) => {
    const places = cycle.cycleIndex === targetCycleIndex ? sortedPlaces : cycle.places;
    // 地点内の operation の順は崩さない（同じ拠点での積み降ろしの順序）
    return places.flatMap((place) => place.operationIds);
  });
}
